/**
 * The Persian this surface says, in one place.
 *
 * Kept out of the components on purpose: a flat list is where a calque is
 * obvious, and short labels — not paragraphs — are where they ship. Read these
 * aloud before adding one.
 */
import type { Role } from '@afra/shared'

export const ROLE_FA: Record<Role, string> = {
  member: 'کاربر',
  org_admin: 'مدیر مؤسسه',
  afra_admin: 'کارشناس افرا',
  super_admin: 'مدیر ارشد',
  assessor: 'ارزیاب',
}

export const STATUS_FA: Record<string, string> = {
  active: 'فعال',
  disabled: 'غیرفعال',
  suspended: 'معلق',
}

export const INVITE_KIND_FA = {
  new_org: 'مؤسسهٔ تازه',
  legacy_charity: 'مؤسسه‌ای از فهرست افرا',
  existing_org: 'مؤسسه‌ای که در سامانه هست',
} as const

/**
 * What each admin action was, said plainly. Anything not listed shows its own
 * code — a trail that hides an action it does not recognise is worse than one
 * that admits it.
 */
export const ACTION_FA: Record<string, string> = {
  'admin.impersonate_start': 'ورود به‌جای مؤسسه',
  'admin.impersonate_end': 'بازگشت از مؤسسه',
  'admin.staff_create': 'تعریف کارشناس',
  'admin.user_create': 'ساختن حساب',
  'admin.user_status': 'تغییر وضعیت حساب',
  'admin.user_role': 'تغییر نقش',
  'admin.password_reset': 'تغییر گذرواژه',
  'admin.invite_create': 'ساختن کد دعوت',
  'admin.invite_revoke': 'باطل کردن کد دعوت',
  'admin.org_status': 'تغییر وضعیت مؤسسه',
  'admin.sentiment_view': 'دیدن رضایت کاربران از گفت‌وگو',
  'admin.legacy_import': 'آوردن داده‌های قبلی از پرتال',
  'chat.reset': 'شروع دوبارهٔ گفت‌وگو',
  'chat.archive': 'بایگانی گفت‌وگو',
  'chat.export': 'خروجی گرفتن از گفت‌وگو',
  'auth.password_change': 'عوض کردن گذرواژه به دست خودش',
}

/** Persian digits, so a number in a sentence does not switch script mid-line. */
export function faNum(n: number | string): string {
  return String(n).replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[Number(d)] ?? d)
}

/** A date as the Iranian calendar writes it. Never a bare ISO string. */
export function faDate(iso: string | null): string {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '—'
  return new Intl.DateTimeFormat('fa-IR', { dateStyle: 'medium' }).format(date)
}

export function faDateTime(iso: string | null): string {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '—'
  return new Intl.DateTimeFormat('fa-IR', { dateStyle: 'short', timeStyle: 'short' }).format(date)
}
